import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseListComponent } from '../../base-list.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ModalType } from '../modal.const';
import { AgentModalSearch, AgentModalType, AgentModelConst, getWidthSearch } from './agent-modal.const';
import { UserService } from '../../../common/services/User.service';
import { QueueService } from '../../../common/services/Queue.service';
import * as _ from 'lodash';
import { GroupService } from '../../../common/services/Group.service';
import { Observable } from 'rxjs';
import { FormFieldConst, FormFieldType } from '../modal-form-template/modal-form.const';

@Component({
  selector: 'app-agent-modal',
  templateUrl: './agent-modal.component.html',
  styleUrls: ['./agent-modal.component.css'],
  providers: [UserService, QueueService, GroupService],
})
export class AgentModalComponent extends BaseListComponent implements OnChanges {
  @Input() content: any = { type: ModalType.Primary, title: 'Modal' };
  @Input() type: any = AgentModalType.AGENT_TO_TRANSPORT;
  @Input() options: any = {};
  @Input() onReload = false;

  @Output() onCloseModal = new EventEmitter<any>();
  @Output() onActionModal = new EventEmitter<any>();

  public customActionModal: any = [];
  public showSelection = true;
  public modelFilter: any = {};
  public filterSearch: any = [];
  public allGroups: any = [];
  public agentInQueue: any = [];
  public inQueueStatus: any = [
    {
      text: 'Trạng thái hiện tại',
      id: '',
    },
    {
      text: 'Trong hàng đợi',
      id: '1',
    },
    {
      text: 'Chưa gán vào hàng đợi',
      id: '2',
    },
  ];
  public readonly getWidthSearch = getWidthSearch;
  public readonly FormFieldType = FormFieldType;
  public readonly AgentModalSearch = AgentModalSearch;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private userService: UserService,
    private queueService: QueueService,
    private groupService: GroupService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {
    this.displayColumns = AgentModelConst.displayColumns(this.type);
    this.customActionModal = AgentModelConst.getAgentModalAction(this.type);
    this.filterSearch = AgentModelConst.getFilterSearch(this.type);
    Observable.forkJoin([this.loadGroups()]).subscribe(res => {
      this.loadData();
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.onReload && !changes.onReload.firstChange) {
      if (this.onReload !== false) {
        this.lstChecked = [];
        this.search().then();
      }
    }
  }

  loadGroups() {
    return this.groupService.allGroup({ target: 'user' }).map(res => {
      const roomList = [{ id: '', text: 'Bộ phận' }];
      res.data.forEach((c: any) => {
        roomList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allGroups = roomList;
    });
  }

  async loadData(request: any = {}, sort: any = {}) {
    if (!request['filters']) {
      request['filters'] = JSON.stringify([
        {
          key: 'active',
          condition: '=',
          value: true,
        },
      ]);
    }

    const search = await this.buildSearch();

    if (search) {
      request = search;
    }

    switch (this.type) {
      case AgentModalType.AGENT_TO_TRANSPORT:
        this.showSelection = false;
        await this.loadAllAgent(request, sort);
        break;
      case AgentModalType.AGENT_IN_QUEUE:
        await this.loadAgentInQueue(request, sort);
        break;
      case AgentModalType.AGENT_IN_ROOM:
        await this.loadAgentInRoom(request, sort);
        break;
      case AgentModalType.AGENT_READY_TO_CALL:
        request['filters'] = [
          {
            key: 'avaiable_status',
            condition: '=',
            value: 'AVAILABLE',
          },
          {
            key: 'is_online',
            condition: '=',
            value: 1,
          },
        ];
        request = await this.buildSearch(request);
        await this.loadAgentReadyToCall(request, sort);
        break;
      default:
        break;
    }
  }

  async reloadFilter() {
    this.modelFilter = {
      name: '',
      email: '',
      group_id: '',
      in_queue: '',
    };
    await this.loadData();
  }

  async buildSearch(request = {}) {
    let filters = [];
    if (Array.isArray(request['filters']) && request['filters'].length > 0) {
      filters = request['filters'];
    }
    filters.push({
      key: 'active',
      condition: '=',
      value: true,
    });
    if (!_.isEmpty(this.modelFilter.name) || this.modelFilter.name) {
      filters.push({
        key: 'name',
        condition: '=',
        value: this.modelFilter.name,
      });
    }
    if (!_.isEmpty(this.modelFilter.email) || this.modelFilter.email) {
      filters.push({
        key: 'email',
        condition: '=',
        value: this.modelFilter.email,
      });
    }
    if (!_.isEmpty(this.modelFilter.group_id) || this.modelFilter.group_id) {
      filters.push({
        key: 'group_id',
        condition: '=',
        value: this.modelFilter.group_id,
      });
    }
    if (!_.isEmpty(this.modelFilter.in_queue) || this.modelFilter.in_queue) {
      request['in_queue'] = this.modelFilter.in_queue == '1';
      request['queue_id'] = this.options.queue_id;
    }
    if (!_.isEmpty(this.modelFilter.in_queue) || this.modelFilter.in_queue) {
      request['in_queue'] = this.modelFilter.in_queue == '1';
      request['queue_id'] = this.options.queue_id;
    }
    filters.push({
      key: 'active',
      condition: '=',
      value: true,
    });
    request['filters'] = JSON.stringify(filters);
    return request;
  }

  async search() {
    this.currentPage = 1;
    const request = await this.buildSearch();
    await this.loadData(request);
  }

  async changeGroup($event) {
    this.modelFilter.group_id = $event.value;
    if (this.modelFilter.group_id === 'Bộ phận' || !this.modelFilter.group_id) {
      delete this.modelFilter.group_id;
    }
    await this.search();
  }

  async changeInQueue($event) {
    this.modelFilter.in_queue = $event.value;
    if (this.modelFilter.in_queue === 'Trạng thái' || !this.modelFilter.in_queue) {
      delete this.modelFilter.in_queue;
    }
    await this.search();
  }

  async loadAllAgent(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.userService.list(payload).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data.list;
        this.data = this.data.map(r => {
          r.display_role = AgentModelConst.displayRoleColumns(r, this.user._id);
          r.display_btn_action_status = true;
          return r;
        });
        this.initPage(res.data.total);
      } else {
        this.data = [];
      }
    });
  }

  async loadAgentInQueue(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    console.log(payload, 'payload');
    this.userService.list(payload).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data.list;
        this.data = this.data
          .filter(r => r.active)
          .map(r => {
            r.display_role = AgentModelConst.displayRoleColumns(r, this.user._id);
            return r;
          });
        this.initPage(res.data.total);
        this.queueService.agentInQueue(this.options.queue_id).subscribe(res => {
          if (res.status == 200 && !res.error) {
            this.agentInQueue = res.data;
            this.data = this.data.map(r => {
              const check = _.find(this.agentInQueue, {
                AGENT_ID: r.agent_id,
              });
              if (check) {
                r.display_btn_action_status = true;
                r.priority = check.PRIORITY;
              } else {
                r.display_btn_action_status = false;
              }
              r.display_priority = AgentModelConst.displayPriorityColumns(r);
              return r;
            });
          }
        });
      } else {
        this.data = [];
      }
    });
  }
  async loadAgentReadyToCall(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.userService.list(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.data = res.data.list;
          this.data = this.data.map(r => {
            r.display_role = AgentModelConst.displayRoleColumns(r, this.user._id);
            r.display_btn_action_status = true;
            return r;
          });
          this.initPage(res.data.total);
        } else {
          this.data = [];
        }
      },
      error => {},
      () => {
        console.log(this.data);
      }
    );
  }

  async loadAgentInRoom(request: any = {}, sort: any = {}) {}

  async handleMultiAction(type) {
    switch (this.type) {
      case AgentModalType.AGENT_IN_QUEUE:
        const agentIds = this.data.filter(a => this.lstChecked.includes(a._id)).map(a => a.agent_id);
        this.onActionModal.emit({ type: type, item: agentIds });
        break;
    }
  }

  async handleAction(type: any, item?: any) {
    this.onActionModal.emit({ type: type, item: item });
  }

  closeModal() {
    this.onCloseModal.emit(true);
  }

  triggerChangeEvent(event: MouseEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    });
    inputElement.dispatchEvent(changeEvent);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/agent-modal/agent-modal.component.ts